import {useSingleSelectListState as $a9c3b$useSingleSelectListState} from "@react-stately/list";
import {useEffect as $a9c3b$useEffect} from "react";

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}
var $ead76093e5740fb6$exports = {};

$parcel$export($ead76093e5740fb6$exports, "useTabListState", () => $ead76093e5740fb6$export$4ba071daf4e486);


function $ead76093e5740fb6$export$4ba071daf4e486(props) {
    let state = $a9c3b$useSingleSelectListState({
        ...props,
        suppressTextValueWarning: true
    });
    $a9c3b$useEffect(()=>{
        // Ensure a tab is always selected (in case no selected key was specified or if selected item was deleted from collection)
        let selectedKey = state.selectedKey;
        if (state.selectionManager.isEmpty || !state.collection.getItem(selectedKey)) {
            selectedKey = state.collection.getFirstKey();
            state.selectionManager.replaceSelection(selectedKey);
        }
        if (state.selectionManager.focusedKey == null) state.selectionManager.setFocusedKey(selectedKey);
    }, [
        state.selectionManager,
        state.selectedKey,
        state.collection
    ]);
    return state;
}




export {$ead76093e5740fb6$export$4ba071daf4e486 as useTabListState};
//# sourceMappingURL=module.js.map
